"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useShoppingCart = exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactRedux = require("react-redux");
var _core = require("@material-ui/core");
var _ShoppingCart = _interopRequireDefault(require("@material-ui/icons/ShoppingCart"));
var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));
var _ShoppingCartOutlined = _interopRequireDefault(require("@material-ui/icons/ShoppingCartOutlined"));
var _Step = _interopRequireDefault(require("@material-ui/core/Step"));
var _reactRouterDom = require("react-router-dom");
var _reactLoading = _interopRequireDefault(require("react-loading"));
var _CreditCard = _interopRequireDefault(require("@material-ui/icons/CreditCard"));
var _Translations = require("react-platform-components/dist/Translations");
var _ConfrimationDialog = require("react-platform-components/dist/components/ConfrimationDialog/ConfrimationDialog");
var _PaymentStep = require("./steps/PaymentStep");
var _GeneralStep = require("./steps/GeneralStep");
var _OrderSummary = require("./components/OrderSummary");
var _CustomStepper = require("./components/CustomStepper");
var _config = require("../config");
var _hooks = require("./hooks");
var _bs = require("react-icons/bs");
var _LoadingPage = require("react-platform-components/dist/components/LoadingPage");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var getShippingSteps;
try {
  getShippingSteps = require('react-platform-shipping/dist/shoppingCartShipping/steps').getShippingSteps;
} catch (error) {}

// Uee withPayment to handle the payment for each our payment solution
var withPayment = {};
try {
  var withStripePayment = require('react-platform-stripe/dist/StripePayment/StripePayment').withStripePayment;
  withPayment[_config.PAYMENT_METHODS.STRIPE] = withStripePayment;
} catch (error) {}
try {
  var withMangopayPayment = require('react-platform-mangopay/dist/MangopayPayment/MangopayPayment').withMangopayPayment;
  withPayment[_config.PAYMENT_METHODS.MANGOPAY] = withMangopayPayment;
} catch (error) {}
var CreditCardsStep;
try {
  CreditCardsStep = require('react-platform-mangopay/dist/CreditCard/CreditCardsList').CreditCardsList;
} catch (error) {}
var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    loadingAreaContainer: _defineProperty({
      paddingBottom: '6rem',
      paddingTop: '12rem',
      paddingRight: '12rem',
      paddingLeft: '12rem'
    }, theme.breakpoints.down('sm'), {
      paddingLeft: 4,
      paddingRight: 4,
      paddingTop: '8rem'
    }),
    loadingTextContainer: {
      textAlign: 'center'
    },
    emptyDataAreaContainer: _defineProperty({
      paddingTop: '12rem'
    }, theme.breakpoints.down('sm'), {
      paddingTop: '8rem'
    }),
    emptyDataAreaIcon: {
      fontSize: 90
    },
    emptyDataDescriptionContainer: {
      paddingTop: '0.5rem',
      paddingBottom: '4rem'
    },
    emptyDataDescription: {
      color: "#9e9e9e"
    },
    stepperHeadContainer: {
      paddingTop: '2rem'
    },
    stepperHeadContainerWrapper: {
      width: '100%'
    },
    stepTitle: {
      marginTop: -88
    },
    stepperBodyContainer: {
      padding: '1rem',
      paddingBottom: '2rem'
    },
    orderSummaryContainer: _defineProperty({
      padding: '1rem',
      paddingLeft: 0
    }, theme.breakpoints.down('sm'), {
      paddingLeft: '1rem'
    })
  };
});
var useShoppingCart = (0, _hooks.BuilderUseShoppingCart)();
exports.useShoppingCart = useShoppingCart;
var ShoppingCart = function ShoppingCart(props) {
  var _cartItems$, _cartItems$$options_l, _cartItems$2, _cartItems$2$options_, _primaryCartItemsGrou;
  var _useSelector = (0, _reactRedux.useSelector)(function (_ref) {
      var mangopayReducer = _ref.mangopayReducer;
      return {
        creditCardSelected: mangopayReducer === null || mangopayReducer === void 0 ? void 0 : mangopayReducer.creditCardSelected
      };
    }),
    creditCardSelected = _useSelector.creditCardSelected;
  var _props$useShoppingCar = props.useShoppingCartHook,
    useShoppingCartHook = _props$useShoppingCar === void 0 ? useShoppingCart : _props$useShoppingCar;
  var classes = useStyles();
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    stepIndex = _useState2[0],
    setStepIndex = _useState2[1];
  var theme = (0, _core.useTheme)();
  var isSm = (0, _useMediaQuery.default)(theme.breakpoints.down('sm'));
  var _useShoppingCartHook = useShoppingCartHook(),
    shoppingCartType = _useShoppingCartHook.shoppingCartType,
    fetchCartInProgress = _useShoppingCartHook.fetchCartInProgress,
    fetchCartItemsInProgress = _useShoppingCartHook.fetchCartItemsInProgress,
    cart = _useShoppingCartHook.cart,
    wallet = _useShoppingCartHook.wallet,
    cartItems = _useShoppingCartHook.cartItems,
    primaryCartItems = _useShoppingCartHook.primaryCartItems,
    primaryCartItemsGroupedBySeller = _useShoppingCartHook.primaryCartItemsGroupedBySeller,
    subTotal = _useShoppingCartHook.subTotal,
    subTotalOriginal = _useShoppingCartHook.subTotalOriginal,
    itemsNumber = _useShoppingCartHook.itemsNumber,
    buyerCommission = _useShoppingCartHook.buyerCommission,
    calculateAmountToBePayed = _useShoppingCartHook.calculateAmountToBePayed,
    onUpdateQuantityOfCartItem = _useShoppingCartHook.onUpdateQuantityOfCartItem,
    onDeleteCartItem = _useShoppingCartHook.onDeleteCartItem,
    onUpdateCartItems = _useShoppingCartHook.onUpdateCartItems;
  var reservationDays = ((_cartItems$ = cartItems[0]) === null || _cartItems$ === void 0 ? void 0 : (_cartItems$$options_l = _cartItems$.options_linked_to_cart_item[0]) === null || _cartItems$$options_l === void 0 ? void 0 : _cartItems$$options_l.extra_data.num_periodicity) * ((_cartItems$2 = cartItems[0]) === null || _cartItems$2 === void 0 ? void 0 : (_cartItems$2$options_ = _cartItems$2.options_linked_to_cart_item[0]) === null || _cartItems$2$options_ === void 0 ? void 0 : _cartItems$2$options_.extra_data.periodicity);
  var isReservation = shoppingCartType.shoppingMethod === 'reservation';
  (0, _react.useEffect)(function () {
    // in the mobile we scroll to the top when we move from a step to other.
    if (isSm) {
      window.scrollTo({
        top: 180,
        behavior: 'smooth'
      });
    }
  }, [stepIndex]);

  // If this type of shopping cart not present we make redirect to dashborad
  if (!shoppingCartType) {
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
      to: '/'
    });
  }

  // Display loading when we send a request
  if (_lodash.default.isEmpty(cartItems) && (fetchCartInProgress || fetchCartItemsInProgress)) {
    return /*#__PURE__*/_react.default.createElement(_LoadingPage.LoadingPage, {
      loadingText: "Obtenir votre panier, veuillez patienter..."
    });
  }

  // Display empty cart when our cart is empty
  if (_lodash.default.isEmpty(cartItems)) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      className: classes.emptyDataAreaContainer
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      item: true,
      md: 12,
      justifyContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_ShoppingCartOutlined.default, {
      color: "primary",
      fontSize: "large",
      className: classes.emptyDataAreaIcon
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      item: true,
      md: 12,
      justifyContent: "center",
      alignItems: "center",
      className: classes.emptyDataDescriptionContainer
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      variant: "h6",
      className: classes.emptyDataDescription
    }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Your cart is empty",
      defaultMessage: "Your cart is empty"
    }))), !shoppingCartType.isSubscription && /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true,
      item: true,
      md: 12,
      justifyContent: "center",
      alignItems: "center"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      variant: "contained",
      color: "secondary",
      "aria-label": "delete",
      disableElevation: true,
      onClick: function onClick() {
        window.location.href = "".concat(_config.BASE_URL).concat(_config.CONTINUE_SHOPPING_LINK);
      }
    }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Continue shopping",
      defaultMessage: "Continue shopping"
    }))));
  }
  var handleClickNext = function handleClickNext() {
    var currentStep = steps[stepIndex];
    if (!currentStep.validate || currentStep.validate(primaryCartItems)) {
      setStepIndex(stepIndex + 1);
    }
  };
  var handlePreviewClick = function handlePreviewClick() {
    if (stepIndex > 0) setStepIndex(stepIndex - 1);
  };
  var isDisabledNextButton = function isDisabledNextButton() {
    var currentStep = steps[stepIndex];
    if (currentStep.validate && !currentStep.validate(primaryCartItems)) return true;
    return false;
  };
  var shippingSteps = getShippingSteps ? getShippingSteps({
    cartItems: primaryCartItems,
    cartItemsGroupedBySeller: primaryCartItemsGroupedBySeller,
    onUpdateCartItems: onUpdateCartItems
  }) : [];
  var isFeatureProduct = ((_primaryCartItemsGrou = primaryCartItemsGroupedBySeller[0]) === null || _primaryCartItemsGrou === void 0 ? void 0 : _primaryCartItemsGrou.seller) === null;
  var steps = [{
    index: 0,
    name: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "My cart",
      defaultMessage: "My cart"
    }),
    icon: /*#__PURE__*/_react.default.createElement(_ShoppingCart.default, null),
    component: /*#__PURE__*/_react.default.createElement(_GeneralStep.GeneralStep, {
      onUpdateQuantityOfCartItem: onUpdateQuantityOfCartItem,
      onDeleteCartItem: onDeleteCartItem,
      cartItemsBySellers: primaryCartItemsGroupedBySeller,
      isSubscription: shoppingCartType.isSubscription
    })
  }].concat(_toConsumableArray(shippingSteps), _toConsumableArray(CreditCardsStep && _config.PAYMENT_MODE === 'pre_authorization' && !isFeatureProduct ? [{
    index: shippingSteps.length + 1,
    name: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "credit cards"
    }),
    icon: /*#__PURE__*/_react.default.createElement(_bs.BsFillCreditCard2FrontFill, null),
    component: /*#__PURE__*/_react.default.createElement(CreditCardsStep, {
      show: true
    }),
    validate: function validate() {
      return creditCardSelected;
    },
    nextButtonTitle: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Select Credit Card"
    })
  }] : []), [{
    index: shippingSteps.length + (_config.PAYMENT_MODE === 'pre_authorization' && !isFeatureProduct ? 2 : 1),
    name: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Payment",
      defaultMessage: "Payment"
    }),
    icon: /*#__PURE__*/_react.default.createElement(_CreditCard.default, null),
    component: withPayment[shoppingCartType.paymentMethod](function (props) {
      return /*#__PURE__*/_react.default.createElement(_PaymentStep.PaymentStep, _extends({
        itemsNumber: itemsNumber,
        subTotal: subTotal,
        totalAmount: cart.total_amount,
        subTotalOriginal: subTotalOriginal,
        shippingAmount: cart.shipping_amount,
        hasShipping: Boolean(getShippingSteps),
        total: calculateAmountToBePayed(),
        onClickPrevious: handlePreviewClick,
        balance: _lodash.default.get(wallet, 'available_balance', undefined),
        buyerCommission: buyerCommission,
        cautionTotal: cautionTotal || 0,
        reservationDays: reservationDays,
        isReservation: isReservation
      }, props));
    }, {
      cartId: cart.id,
      creditCardId: creditCardSelected,
      featureProduct: isFeatureProduct
    }),
    nextButtonTitle: /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
      id: "Passer au Paiement"
    })
  }]);
  var getButtonTitleOfNextStep = function getButtonTitleOfNextStep() {
    var _steps;
    return (_steps = steps[stepIndex + 1]) === null || _steps === void 0 ? void 0 : _steps.nextButtonTitle;
  };
  var isLastStep = stepIndex < steps.length - 1;
  var cautionTotal = cartItems === null || cartItems === void 0 ? void 0 : cartItems.reduce(function (accumulator, currentValue) {
    var _currentValue$salable, _currentValue$salable2;
    return accumulator + (currentValue === null || currentValue === void 0 ? void 0 : (_currentValue$salable = currentValue.salable_item) === null || _currentValue$salable === void 0 ? void 0 : (_currentValue$salable2 = _currentValue$salable.product_caution) === null || _currentValue$salable2 === void 0 ? void 0 : _currentValue$salable2.amount) * (currentValue === null || currentValue === void 0 ? void 0 : currentValue.quantity);
  }, 0);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    md: 12,
    className: classes.stepperHeadContainerWrapper
  }, /*#__PURE__*/_react.default.createElement(_core.Paper, {
    elevation: 0,
    className: classes.stepperHeadContainer
  }, /*#__PURE__*/_react.default.createElement(_CustomStepper.CustomStepper, {
    activeStep: stepIndex
  }, steps.map(function (step) {
    return /*#__PURE__*/_react.default.createElement(_Step.default, {
      key: step.name
    }, /*#__PURE__*/_react.default.createElement(_CustomStepper.CustomStepLabel, {
      getIcon: function getIcon(step) {
        return steps[step - 1].icon;
      }
    }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
      className: classes.stepTitle
    }, step.name)));
  })))), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    md: 12,
    lg: isLastStep ? 8 : 12,
    className: classes.stepperBodyContainer
  }, steps.map(function (step) {
    return stepIndex === step.index ? step.component : null;
  })), isLastStep && /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    md: 12,
    lg: 4,
    className: classes.orderSummaryContainer
  }, /*#__PURE__*/_react.default.createElement(_OrderSummary.OrderSummary, {
    itemsNumber: itemsNumber,
    subTotal: subTotal,
    totalAmount: cart.total_amount,
    shippingAmount: cart.shipping_amount,
    hasShipping: Boolean(getShippingSteps),
    total: calculateAmountToBePayed(),
    step: stepIndex,
    buttonTitleToGoToNextStep: getButtonTitleOfNextStep(),
    onClickNext: handleClickNext,
    onClickPrevious: handlePreviewClick,
    disabledNextButton: isDisabledNextButton(),
    balance: _lodash.default.get(wallet, 'available_balance', undefined),
    buyerCommission: buyerCommission,
    subTotalOriginal: subTotalOriginal,
    cautionTotal: cautionTotal || 0,
    reservationDays: reservationDays,
    isReservation: isReservation
  }))));
};
var _default = ShoppingCart;
exports.default = _default;